module.exports = __webpack_public_path__ + "static/media/toc.797aadf6.mp3";